/**
 * @since 0.1.27
 */
import { flow } from 'fp-ts/es6/function';
import * as RTE from 'fp-ts/es6/ReaderTaskEither';
import * as TE from 'fp-ts/es6/TaskEither';
// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * @category constructors
 * @since 0.1.27
 */
export var leftReaderIO = function (me) {
    return flow(me, TE.leftIO);
};
/**
 * @category constructors
 * @since 0.1.27
 */
export var rightReaderIO = function (ma) {
    return flow(ma, TE.rightIO);
};
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * @category combinators
 * @since 0.1.27
 */
export var fromReaderIOK = function (f) { return function () {
    var a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        a[_i] = arguments[_i];
    }
    return rightReaderIO(f.apply(void 0, a));
}; };
/**
 * Less strict version of [`chainReaderIOK`](#chainreaderiok).
 *
 * @category combinators
 * @since 0.1.27
 */
export var chainReaderIOKW = function (f) {
    return RTE.chainW(fromReaderIOK(f));
};
/**
 * @category combinators
 * @since 0.1.27
 */
export var chainReaderIOK = chainReaderIOKW;
/**
 * Less strict version of [`chainFirstReaderIOK`](#chainfirstreaderiok).
 *
 * @category combinators
 * @since 0.1.27
 */
export var chainFirstReaderIOKW = function (f) {
    return RTE.chainFirstW(fromReaderIOK(f));
};
/**
 * @category combinators
 * @since 0.1.27
 */
export var chainFirstReaderIOK = chainFirstReaderIOKW;
